var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationRouter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Router",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 369.18 288.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "99.25 19.58 99.25 168.8 120.47 168.09 121.96 6.34 99.25 19.58",
    fill: "#dbdcdd",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "253.25 16.74 253.25 165.97 274.48 170.78 275.97 3.5 253.25 16.74",
    fill: "#dbdcdd",
    strokeWidth: 0
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.96 3.5 99.25 16.74 99.25 170.78 121.96 166.22 121.96 3.5",
    fill: "none",
    stroke: "#4a4f57",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "275.24 3.5 252.52 16.74 252.52 166.58 275.24 171.4 275.24 3.5",
    fill: "none",
    stroke: "#4a4f57",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "2.66 285.67 365.68 285.67 365.68 246.52 282.95 230.34 92.25 230.58 2.66 246.98 2.66 285.67",
    fill: "#35c0e2",
    strokeWidth: 0
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "72.83 167.97 3.5 246.86 90.3 229.76 280.37 228.68 363.63 244 299.58 164.98 237.71 155.62 131.15 157.04 72.83 167.97",
    fill: "#35c0e2",
    strokeWidth: 0
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "365.68 285.24 3.5 285.24 3.5 246.86 96.96 230.26 277.32 230.26 365.68 246.86 365.68 285.24",
    fill: "none",
    stroke: "#4a4f57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "365.68 246.52 277.32 230.24 96.08 230.24 3.5 246.52 72.83 167.97 136.31 155.64 236.23 155.64 299.85 168.4 365.68 246.52",
    fill: "none",
    stroke: "#4a4f57",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.77,
    cy: 262.22,
    r: 7.24,
    fill: "#4a4f57",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.54,
    cy: 262.22,
    r: 7.24,
    fill: "#4a4f57",
    strokeWidth: 0
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.22,
    cy: 262.22,
    r: 7.24,
    fill: "#fff",
    stroke: "#4a4f57",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 113.22,
    y1: 212.85,
    x2: 259.5,
    y2: 212.85,
    fill: "none",
    stroke: "#4a4f57",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 118.91,
    y1: 201.64,
    x2: 253.86,
    y2: 201.64,
    fill: "none",
    stroke: "#4a4f57",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 125.59,
    y1: 190.44,
    x2: 247.12,
    y2: 190.44,
    fill: "none",
    stroke: "#4a4f57",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 236.23,
    y1: 155.82,
    x2: 278.56,
    y2: 230.24,
    fill: "none",
    stroke: "#4a4f57",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 137.82,
    y1: 155.82,
    x2: 95.49,
    y2: 230.24,
    fill: "none",
    stroke: "#4a4f57",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationRouter);
export default __webpack_public_path__ + "static/media/Illustration-Router.dc3e71190a0bc07b16ee25ff6f5ff557.svg";
export { ForwardRef as ReactComponent };